export const GUEST_DRAFT_KEY = "reviewed.guest-draft";
export type GuestDraft = {
  text: string;
  topic: string;
  country: string;
  region: string;
  at: number;
  version: 1;
};
export function readGuestDraft(): GuestDraft | null {
  try {
    const d = JSON.parse(sessionStorage.getItem(GUEST_DRAFT_KEY) || "null");
    if (
      d?.version === 1 &&
      typeof d.text === "string" &&
      d.text.length <= 20000 &&
      typeof d.topic === "string" &&
      d.topic.length <= 80 &&
      /^[A-Z]{2}$/.test(d.country) &&
      typeof d.region === "string" &&
      d.region.length <= 200 &&
      Number.isFinite(d.at) &&
      d.at <= Date.now() &&
      Date.now() - d.at < 86400000
    )
      return d;
    sessionStorage.removeItem(GUEST_DRAFT_KEY);
  } catch {
    /* storage is optional */
  }
  return null;
}
export function saveGuestDraft(draft: Omit<GuestDraft, "at" | "version">) {
  try {
    sessionStorage.setItem(
      GUEST_DRAFT_KEY,
      JSON.stringify({ ...draft, at: Date.now(), version: 1 })
    );
    return true;
  } catch {
    return false;
  }
}
export function discardGuestDraft() {
  try {
    sessionStorage.removeItem(GUEST_DRAFT_KEY);
  } catch {}
}
